const validationThreshold = 20;

const characterCountClasses = {
  close: "character-count--close",
  error: "character-count--error",
  normal: "character-count--normal",
};

const instance = ($input: HTMLInputElement | HTMLTextAreaElement) => {
  // 255 is a default which shouldn't be shown
  if (!$input.maxLength || $input.maxLength === 255) {
    return;
  }

  const characterCount = document.createElement("span");
  characterCount.classList.add("umbraco-forms-tooltip");
  characterCount.classList.add("help-block");
  characterCount.classList.add("character-count");

  $input.parentNode.insertBefore(characterCount, $input.nextSibling);

  const countCharacters = () => {
    const numOfEnteredChars = $input.value.length;
    let counter = $input.maxLength - numOfEnteredChars;

    if (
      counter < 0 ||
      ($input.maxLength > validationThreshold && counter === 0)
    ) {
      counter = 0;

      characterCount.classList.remove(characterCountClasses.close);
      characterCount.classList.add(characterCountClasses.error);
      characterCount.classList.remove(characterCountClasses.normal);
    } else if (
      $input.maxLength > validationThreshold &&
      counter < validationThreshold
    ) {
      characterCount.classList.add(characterCountClasses.close);
      characterCount.classList.remove(characterCountClasses.error);
      characterCount.classList.remove(characterCountClasses.normal);
    } else {
      characterCount.classList.remove(characterCountClasses.close);
      characterCount.classList.remove(characterCountClasses.error);
      characterCount.classList.add(characterCountClasses.normal);
    }

    characterCount.textContent = `${
      $input.maxLength > validationThreshold ? "Remaining characters: " : ""
    }${counter}/${$input.maxLength}`;
  };

  $input.addEventListener("input", countCharacters);
  countCharacters();
};

const maxCharacterCounts = () => {
  const SELECTOR = ".umbraco-forms-field-wrapper .show-counter[maxlength]";
  document.querySelectorAll(SELECTOR).forEach(($el: Element) => {
    const $htmlElement = $el as HTMLInputElement | HTMLTextAreaElement;

    instance($htmlElement);
  });
};

export default maxCharacterCounts;
